export const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "100vh",
    paddingTop: "12px",
    paddingBottom: "32px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "5px",
    width: "220px",
    alignItems: "center",
  },
  button: {
    padding: "10px 20px",
    fontSize: "18px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    backgroundColor: "#6a1b9a",
    color: "white",
    cursor: "pointer",
    width: "200px",
    textAlign: "center" as const,
  },
};
